<div class="tw-flex tw-flex-col tw-h-full">
  <p class="tw-font-strong tw-mb-1.5">
    <ng-container *ngIf="label">
      {{ label }}
    </ng-container>
    <ng-container *ngIf="!label">
      <ng-content select="[title]"></ng-content>
    </ng-container>
  </p>
  <p>
    <ng-container *ngIf="text">
      {{ text }}
    </ng-container>
    <ng-container *ngIf="!text">
      <ng-content select="[text]"></ng-content>
    </ng-container>
  </p>
</div>
